module.exports = __webpack_public_path__ + "static/media/lana-del-rey-lose.961ca043.jpg";